import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { User } from "../../models/user";
import { TeamsService } from "../../services/teams/teams.service";

@Injectable({
  providedIn: "root",
})
export class LoggedInGuard implements CanActivate {
  constructor(private userService: TeamsService, private router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    try {
      let value = await this.userService.fetchUser();

      let user: User = {
        idUser: value.idUser,
        prenomUser: value.prenomUser,
        nomUser: value.nomUser,
        telUser: value.telUser,
        login: value.login,
      };

      this.userService.setUser(user);

      return true;
    } catch (err) {
      console.log(err);
      this.router.navigate(["/auth"]);
      return false;
    }
  }
}
